import React from 'react';

import Icon from 'components/Admin/SessionRooms/Table/Icon';
import CellStringItemWithTooltip from 'components/ui/Table/CellStringItemWithTooltip';
import Actions from './Actions';

const columns = [
  {
    name: 'Date',
    selector: (row) => row.start_time,
    cell: (row) => new Date(row.start_time).toLocaleString('en-US'),
    sortable: true,
  },
  {
    name: 'Member',
    selector: (row) => row.chat_info.user_name,
    sortable: true,
  },
  {
    name: 'Avatar',
    selector: (row) => row.chat_info.avatar_name,
    sortable: true,
  },
  {
    name: 'Title',
    selector: (row) => row.title,
    sortable: true,
    cell: (row) => <CellStringItemWithTooltip text={row.title} />,
    maxWidth: '240px',
  },
  {
    name: 'Rating',
    selector: (row) => row.rate,
    cell: (row) => (row.rating > 0 ? <Icon rate={row.rate} /> : ''),
    sortable: true,
  },
  {
    name: 'Type',
    selector: (row) => row.chat_info.session_type,
    sortable: true,
  },
  {
    name: 'Duration(min.)',
    selector: (row) => row.duration,
    cell: (row) => (Math.round(row.duration * 10 / 60) / 10),
    sortable: true,
  },
  {
    name: 'Enterprise',
    selector: (row) => row.chat_info.enterprise,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.chat_info.user_email,
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '100px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
